@use "../../sass/variables/dimensions";

.ux-form-group {
  display: block;
  position: relative;

  &__fieldset {
    border: 0;
    padding: 0;
  }

  &__wrapper {
    align-items: stretch;
    display: flex;
    flex-direction: column;

    > * {
      margin-bottom: dimensions.$dim-10;
    }

    > *:last-child {
      margin-bottom: 0;
    }
  }
}
